module.exports = __webpack_public_path__ + "static/media/ten-10.jpeg";